export default (array: number[]) => {
  if (!Array.isArray(array)) {
    return null;
  }

  return array.reduce((a, c) => a + c, 0) / array.length;
};
